import { QueryEntity, QueryConfig, Order } from '@datorama/akita';
import { PitchPlaylistStore, PitchPlaylistState } from './pitch-playlist.store';
import { PitchPlaylist, PitchPlaylistSong } from './pitch-playlist.model';
import { Injectable } from '@angular/core';
import { map, startWith, switchMap, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

@QueryConfig({
  sortBy: 'position',
  sortByOrder: Order.ASC
})
@Injectable({
  providedIn: 'root'
})
export class PitchPlaylistQuery extends QueryEntity<PitchPlaylistState, PitchPlaylistSong> {
  pitchInfo$ = this.select(state => ({
    id: state.id,
    name: state.name,
    description: state.description,
    clientNote: state.clientNote,
    expectedExpirationDate: state.expectedExpirationDate,
    isDownloadAllSupported: state.isDownloadAllSupported,
    lastModifiedTime: state.lastModifiedTime,
    createdBy: state.createdBy,
    songsPager: state.songsPager,
    createdTime: state.createdTime,
    songs: state.songs,
    playlist: state.playlist,
    showAlbumsArt: state.showAlbumsArt,
    hasHiResolutionAudio: state.hasHiResolutionAudio,
    hasMp3: state.hasMp3,
    attachments: state.attachments,
    userDivision: state.userDivision,
    permissionHash: state.permissionHash
  }));

  activeSong$ = this.select(state => state).pipe(tap(state => console.log(state)));

  pitchSongs$ = this.selectAll();
  selectPitchNotFound$ = this.select(({ ui }) => ui.pitchNotFound);
  selectPitchExpired$ = this.select(({ ui }) => ui.expired);
  selectLoading$ = this.select(({ loading }) => loading);
  selectPitchDownloadSupported$ = this.select(({ ui }) => ui.downloadAllSupported);

  selectTotal$ = this.select().pipe(
    map(state => {
      const total = state.songsPager.total;
      const suffix = total === 1 ? 'Song' : 'Songs';
      return `${total} ${suffix}`;
    }),
    startWith('0 Songs')
  );

  selectCurrentPitch(): Observable<PitchPlaylist> {
    return this.pitchSongs$.pipe(
      switchMap(items => {
        return this.pitchInfo$.pipe(
          map(info => ({
            ...info,
            songs: items
          }))
        );
      })
    );
  }

  constructor(protected store: PitchPlaylistStore) {
    super(store);
  }
}
